export const ESRI_OAUTH_INFO = {
  appId: "ephPh366b8TspMw6",
  portalUrl: "https://tnc.maps.arcgis.com/",
  popup: false,
};

export const ESRI_MAP_DEFAULTS = {
  // center: [-119.75, 34], // SCI
  center: [-120.45, 34.5],
  zoom: 13,
};

export const AGO_DATETIME_FORMAT = "yyyy-MM-dd HH:mm:ss";

// unused since it conflicts with the OAuth login
export const ESRI_API_KEY =
  "AAPK474cf7e4eb2a4e05b3c8e92f8dc644d2UbW-jHT" +
  "PSTbAA7bvSyO-4_n83Ch7xqkZvwQQfE03c9bukDSbrZI8R6kP8tdScdfk";

export const LORA_TRACKING_LAYER = {
  title: "Lora tracking",
  url:
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/arcgis/rest/services/" +
    "lora_tracking_3/FeatureServer/0",
  outFields: ["*"],
  // outStatistics: {
  //  onStatisticField: "rec_tm_utc",
  //  outStatisticFieldName: "time_last",
  //  statisticType: "max",
  //},
  renderer: {
    type: "simple", // autocasts as new SimpleRenderer()
    symbol: {
      type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
      size: 5,
      color: "black",
    },
    visualVariables: [
      {
        type: "color",
        field: "rssi_1",
        stops: [
          { value: -120, color: "#cf597e" },
          { value: -100, color: "#eeb479" },
          { value: -80, color: "#9ccb86" },
          { value: -60, color: "#39b185" },
        ],
        legendOptions: {
          title: "RSSI",
        },
      },
    ],
  },
  popupTemplate: {
    title: "Device: {dev}",
    content:
      "<ul>" +
      "<li><span>RSSI:</span> {rssi_1}</li>" +
      "<li><span>Gateway:</span> {gateway_1}</li>" +
      "<li><span>Gateway count:</span> {gtw_count}</li>" +
      "<li><span>Time:</span> {time}</li>" +
      "<li><span>Received Time:</span> {rec_tm_utc}</li>" +
      "<li><span>dr:</span> {dr}</li>" +
      "<li><span>cr:</span> {cr}</li>" +
      "<li><span>snr:</span> {snr}</li>" +
      "<li><span>Airtime:</span> {airtime_ms}</li>" +
      "<li><span>Frames:</span> {frames}</li>" +
      "</ul>",
  },
  maxTransmissionsAlert:
    "You have exceeded the maximum number of " +
    "transmissions the server can return.",
};

export const radioButtons = [
  { id: "custom", duration: undefined, label: "Custom range", selected: true },
  { id: "lastminute", duration: 60, label: "Last minute", selected: false },
  {
    id: "last10minues",
    duration: 600,
    label: "Last 10 minutes",
    selected: false,
  },
  { id: "lasthour", duration: 3600, label: "Last hour", selected: false },
  { id: "lastday", duration: 86400, label: "Last day", selected: false },
  { id: "last10day", duration: 864000, label: "Last 10 days", selected: false },
];
